<dx-popup
    #creditApplicationBox
    width="70%"
    height="80%"
    [title]="popupTitle"
    [showTitle]="true"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let item of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <cc-data-grid-features
                    [stateConfig]="{ storageKey: 'AP_CREDIT_APPLICATION_GRID' }"
                    [gridFeatures]="{
                        placement: 'top',
                        allowPlacementSwitch: false
                    }"
                    [dataSource]="creditApplicationData"
                >
                    <dx-data-grid
                        width="100%"
                        height="100%"
                        [dataSource]="creditApplicationData"
                        [allowColumnReordering]="true"
                        [allowColumnResizing]="true"
                        [columnAutoWidth]="true"
                        [showBorders]="true"
                        [showColumnLines]="true"
                        [showRowLines]="true"
                        noDataText="No data to display"
                    >
                        <dxi-column
                            caption="Action"
                            dataType="string"
                            alignment="center"
                            cellTemplate="actionTemplate"
                            [showInColumnChooser]="false"
                            [allowFiltering]="false"
                            [allowHeaderFiltering]="false"
                            [allowGrouping]="false"
                            [allowSorting]="false"
                        ></dxi-column>
                        <dxi-column
                            dataField="source.title"
                            caption="Source"
                            dataType="string"
                            cellTemplate="sourceTemplate"
                        ></dxi-column>
                        <dxi-column
                            dataField="target.title"
                            caption="Target"
                            dataType="string"
                            cellTemplate="targetTemplate"
                        ></dxi-column>
                        <dxi-column
                            dataField="amount"
                            caption="Amount"
                            dataType="number"
                            [format]="currencyFormat"
                        ></dxi-column>
                        <dxi-column
                            dataField="appliedDate"
                            caption="Applied Date"
                            dataType="date"
                            [format]="dateFormat"
                        ></dxi-column>
                        <dxi-column
                            dataField="updatedByDisplayText"
                            caption="Updated By"
                            dataType="string"
                            cellTemplate="updatedByUserTemplate"
                        ></dxi-column>
                        <dxi-column dataField="subLedger" caption="Sub Ledger Title" dataType="string"></dxi-column>
                        <dxi-column
                            dataField="reversalDate"
                            caption="Reversal Date"
                            dataType="date"
                            [format]="dateFormat"
                        ></dxi-column>
                        <dxi-column
                            dataField="reversalDescription"
                            caption="Reversal Description"
                            dataType="string"
                        ></dxi-column>

                        <div *dxTemplate="let row of 'actionTemplate'">
                            <dx-button
                                *ngIf="row.data.allowUnapply"
                                type="default"
                                text="Unapply"
                                [width]="90"
                                (onClick)="onUnapplyClick(row.data)"
                            ></dx-button>
                        </div>

                        <div *dxTemplate="let row of 'sourceTemplate'">
                            <app-hyperlink-creator
                                mode="hyperlinkOnly"
                                [displayText]="row.value"
                                (onLinkClick)="onSourceClick(row.data)"
                            ></app-hyperlink-creator>
                        </div>
                        <div *dxTemplate="let row of 'targetTemplate'">
                            <app-hyperlink-creator
                                mode="hyperlinkOnly"
                                [displayText]="row.value"
                                (onLinkClick)="onTargetClick(row.data)"
                            ></app-hyperlink-creator>
                        </div>

                        <div *dxTemplate="let row of 'updatedByUserTemplate'">
                            <app-user-bio-link
                                [user]="row.data.updatedBy"
                                [communityId]="communityId"
                            ></app-user-bio-link>
                        </div>

                        <dxo-summary [calculateCustomSummary]="calculateCustomSummary">
                            <dxi-total-item
                                name="amount"
                                showInColumn="amount"
                                summaryType="custom"
                                dataType="number"
                                displayFormat="Total: {0}"
                                [valueFormat]="currencyFormat"
                            ></dxi-total-item>
                        </dxo-summary>

                        <dxo-header-filter [visible]="false"></dxo-header-filter>
                        <dxo-filter-panel [visible]="false"></dxo-filter-panel>
                        <dxo-group-panel [visible]="false"></dxo-group-panel>
                        <dxo-sorting mode="none"></dxo-sorting>
                        <dxo-scrolling mode="standard"></dxo-scrolling>
                        <dxo-load-panel [enabled]="false"></dxo-load-panel>
                    </dx-data-grid>
                </cc-data-grid-features>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="credit-toolbar">
                    <dx-toolbar>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    [icon]="iconClose"
                                    (onClick)="onHidden()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-ap-payment-details
    *ngIf="apPaymentDetailVisible"
    [visible]="apPaymentDetailVisible"
    [apPaymentParam]="apPaymentParams"
    (onAPPaymentClose)="onAPPaymentDetailClose($event)"
></app-ap-payment-details>

<app-ap-adjustment
    *ngIf="apAdjustmentDetailVisible"
    [visible]="apAdjustmentDetailVisible"
    [adjustmentDetailParam]="apAdjustmentDetailParam"
    (onAdjustmentDetailClose)="onAPAdjustmentDetailClose($event)"
></app-ap-adjustment>

<app-ap-bill-detail
    *ngIf="apBillDetailVisible"
    [visible]="apBillDetailVisible"
    [apBillDetailParam]="apBillDetailParam"
    [isCorporateCirabook]="false"
    (onAPBillDetailClose)="onAPBillDetailClose($event)"
></app-ap-bill-detail>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#creditApplicationBox' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
